import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IFair } from "../types/seed";

const API = process.env.REACT_APP_API;

const useCancelFair = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return fetch(`${API}/api/semeadora/fairs/current/cancel/`, {
        method: "POST",
      }) as Promise<IFair>;
    },
    onError: (error) => {
      console.log("onError", error);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["fair"] });
      queryClient.invalidateQueries({ queryKey: ["fairs"] });
    },
  });
};

export default useCancelFair;
